import React, { Component } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";

import "react-bootstrap-table/dist/react-bootstrap-table.min.css";
import { APP_CONST, getStoredItem } from "../../store/dataStore";
import accountsApi from "../../api/accounts";

import LoadingOverlay from "../Components/LoadingOverlay";
import CurrencyCard from "../Components/CurrencyCard";
import { handleError as originalHandleError } from "@/util/errorHandler";

const handleError = error =>
  originalHandleError(error, { title: error.detail });

class MainAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      khrBalance: 0,
      usdBalance: 0,
      xauBalance: 0,
      isAccountDataLoading: true,
    };
  }

  componentDidMount() {
    this.loadBalance();
  }

  loadBalance = async () => {
    try {
      this.setState({ isAccountDataLoading: true });

      const userInfo = JSON.parse(getStoredItem(APP_CONST.USER_INFO));
      const data = await accountsApi.getMainAccountBalance(
        userInfo.participantBankCode,
      );

      this.setState({
        usdBalance: data.assets["usd#nbc"],
        khrBalance: data.assets["khr#nbc"],
        xauBalance: data.assets["xau#nbc"],
      });
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ isAccountDataLoading: false });
    }
  };

  render() {
    return (
      <div className="animated fadeIn">
        <Row className="mb-4">
          <Col>
            <Card>
              <LoadingOverlay loading={this.state.isAccountDataLoading} />
              <CardHeader>Main Account Balance</CardHeader>
              <CardBody>
                <Row>
                  <Col xl="3" lg="6" sm="6" md="6">
                    <Card>
                      <CardBody style={{ padding: 10 }}>
                        <CurrencyCard
                          title="Riel account"
                          currency="riel"
                          balance={this.state.khrBalance}
                          data-cy="khr-balance"
                        />
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xl="3" lg="6" sm="6" md="6">
                    <Card>
                      <CardBody style={{ padding: 10 }}>
                        <CurrencyCard
                          title="Dollar account"
                          currency="usd"
                          balance={this.state.usdBalance}
                          data-cy="usd-balance"
                        />
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xl="3" lg="6" sm="6" md="6">
                    <Card>
                      <CardBody style={{ padding: 10 }}>
                        <CurrencyCard
                          title="Gold account (chi)"
                          currency="gold"
                          balance={this.state.xauBalance}
                          data-cy="usd-balance"
                        />
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/* TODO: ***Temporary removing this part until implementation on backend is ready***
                <Row className="mt-2 mb-2">
                  <Col>
                    <Card>
                      <CardHeader>Current Account Balance</CardHeader>
                      <CardBody>
                        <BootstrapTable
                          data={this.genAccountData(0)}
                          version="4"
                          striped
                          hover
                          condensed>
                          <TableHeaderColumn
                            dataField="account"
                            isKey
                            dataAlign="center">
                            ACCOUNT
                          </TableHeaderColumn>
                          <TableHeaderColumn
                            dataField="currency"
                            dataAlign="center">
                            CURRENCY
                          </TableHeaderColumn>
                          <TableHeaderColumn
                            dataField="avail_balance"
                            dataAlign="right">
                            AVAILABLE BALANCE
                          </TableHeaderColumn>
                        </BootstrapTable>
                      </CardBody>
                    </Card>
                  </Col>
                </Row> */}
      </div>
    );
  }
}

export default MainAccount;
